import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import Fade from "@mui/material/Fade";

//style={{ color: contrastColour, backgroundColor: primaryColour }}

const replaceParagraphs = text => {
  try {
    let body = text;
    if (body.includes("<p>")) {
      body = body.replace(new RegExp("<p>", "g"), "<span>");
      body = body.replace(new RegExp("</p>", "g"), "</span>");
    }
    return body;
  } catch {
    return text;
  }
};
const SlideBody = ({
  classes,
  headline,
  shouldAnimate,
  color
}) => {
  const body = replaceParagraphs(headline);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.slideBodyContainer
  }, /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 400,
    style: {
      transitionDelay: "0.6s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    className: classes.bodyText,
    component: "span",
    style: {
      color
    }
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: body
    }
  }))));
};
const styles = {
  slideBodyContainer: {
    justifyContent: "center",
    display: "flex",
    flex: 1,
    marginLeft: 20,
    marginRight: 20,
    flexDirection: "column"
  },
  bodyText: {
    overflow: "auto"
  }
};
export default withStyles(styles)(SlideBody);
SlideBody.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool,
  headline: PropTypes.string.isRequired,
  color: PropTypes.string
};